define('tinymce-plugins/wa5_fixbreak/plugin',['tinymce/AddOnManager'], function(AddOnManager) {
	AddOnManager.PluginManager.add('wa5_fixbreak', function(editor) {
		function getTextNodesIn(node, includeWhitespaceNodes) {
			var textNodes = [], whitespace = /^\s*$/;
			var newBlockStarted = false;

			function getTextNodes(node) {
				switch (node.nodeType) {
				case 3: // text
					if (includeWhitespaceNodes || !whitespace.test(node.nodeValue)) {
						node.isNewBlock = newBlockStarted;
						newBlockStarted = false;
						textNodes.push(node);
					}
					break;
				case 1: // element
					if (node.nodeName == 'IMG')
						textNodes.push(node);
					// fall through
				default:
					var isBlockElement = 'p div li blockquote td th h1 h2 h3 br'
						.split(' ').indexOf(node.nodeName.toLowerCase()) >= 0;

					// text nodes in new block element are inherently in new line
					newBlockStarted |= isBlockElement;
					for (var i = 0, len = node.childNodes.length; i < len; ++i) {
						getTextNodes(node.childNodes[i]);
					}
					// text nodes after block elements are inherently in new line, too
					newBlockStarted |= isBlockElement;
				}
			}

			getTextNodes(node);
			return textNodes;
		}

		function addLinebreaks(root) {
			root.normalize(); // merge sibling text nodes into one
			var fixbreakCount = 0;

			// Wrap words into <span>s
			var textNodes = getTextNodesIn(root);
			var oldY = -1;
			var lastNode = null;
			for (var i = 0; i < textNodes.length; i++) {
				var node = textNodes[i];
				if (node.isNewBlock)
					oldY = -1; // do not add linebreaks at beginning of a block

				if (node.nodeName == 'IMG') {
					// ignore floating images because they might have a totally different bottom y position
					// but non-floating images are normal content, so they can indicate break positions
					if ($(node).css('float') == 'none') {
						var newY = $(node).offset().top + $(node).height();
						// Threshold of 10 because images are aligned baseline and not bottom
						if (newY > oldY + 10)
							oldY = newY;
					}
					lastNode = node;
					continue;
				}

				var text = node.textContent;
				var letters = [];
				for (var j = 0; j < text.length; j++) {
					letters.push($('<span>').addClass('letter').text(text[j]));
				}
				$(node).replaceWith(letters);
				var html = '';
				var textSoFar = '';
				for (var j = 0; j < letters.length; j++) {
					var letter = letters[j];
					textSoFar += letter.text();
					var y = letter.offset().top + letter.height();
					// Threshold of 10 because images are aligned baseline and not bottom
					if (oldY >= 0 && y > oldY + 10) {
						// Do not add linebreaks at the beginning of elements, instead, add them
						// to the end of the previous element
						if (textSoFar.length == 1) {
							if (lastNode) {
								$(lastNode).after($('<br class="fixbreak">'));
							}
						} else
							html += '<br class="fixbreak" />';
						fixbreakCount++;
					}
					html += letter.html(); // escape
					oldY = y;
				}
				var newNodes = $.parseHTML(html);
				$(letters[0]).replaceWith(newNodes);
				$(letters).each(function() { $(this).remove()});
				lastNode = newNodes.length ? newNodes[newNodes.length - 1] : null;
			}
		}

		function removeLinebreaks(root) {
			$('br.fixbreak', root).remove();
			root.normalize(); // combine adjacent text nodes
		}

		// insert autobreaks when saving
		editor.on('BeforeGetContent', function(e) {
			if (e.format == 'html' && e.save)
				addLinebreaks(editor.getBody());
		});

		// clean up afterwards
		editor.on('GetContent', function(e) {
			removeLinebreaks(editor.getBody());
		});

		// remove autobreaks for editing
		editor.on('SetContent', function(e) {
			removeLinebreaks(editor.getBody());
		});
		window.addLinebreaks = function() {addLinebreaks(editor.getBody()) };
	});
});

